import { LyfeTooltip, useDataMutation } from "@lyfegen-platform/react-common";
import { Box, IconButton } from "@material-ui/core";
import { DeleteOutline, Undo } from "@material-ui/icons";
import { useTranslation } from "react-i18next";
import { useTimer } from "react-timer-hook";
import { SupportedMessageNodes } from "../../../models/generated/graphql";
import startUpper from "../../../utils/start-upper";
import { DELETE_MESSAGE } from "./queries";
import { SingleMessage } from "./CaseMessages";
import DeletionCountDown from "../../../components/DeletionCountDown";

interface MessageDeletionProps {
	message: SingleMessage;
	nodeId: string;
	nodeLabel: SupportedMessageNodes;
}

const CaseMessageDeletion: React.FC<MessageDeletionProps> = ({ message, nodeId, nodeLabel }) => {
	const expiryTimestamp = new Date(Date.now() + 5000);
	const { t } = useTranslation();
	const { seconds, isRunning, start, restart } = useTimer({ expiryTimestamp: expiryTimestamp, autoStart: false });

	const [mutation] = useDataMutation(DELETE_MESSAGE);

	const handleClickDelete = () => {
		!isRunning ? start() : restart(expiryTimestamp, false);
	};

	const handleRestart = (seconds: number) => {
		if (seconds) return;
		restart(expiryTimestamp, false);
		mutation({ variables: { input: { createdOn: message.createdOn, id: nodeId, nodeLabel } } });
	};

	return (
		<>
			{isRunning && handleRestart(seconds)}
			<Box display="flex" alignItems="center">
				{isRunning && <DeletionCountDown seconds={seconds} />}
				<LyfeTooltip placement="top" title={!isRunning ? startUpper(t("delete")) : startUpper(t("undo"))}>
					<IconButton style={{ marginLeft: "5px" }} onClick={handleClickDelete} size="small">
						{!isRunning ? <DeleteOutline color="primary" /> : <Undo color="primary" />}
					</IconButton>
				</LyfeTooltip>
			</Box>
		</>
	);
};

export default CaseMessageDeletion;
